import Swal from 'sweetalert2';

export function showSwlLoading(text = '') {
    Swal.fire({
        title: '¡Espere por favor!',
        html: `<i class="fa fa-spin fa-spinner"></i><p>(${text})</p>`,
        allowOutsideClick: false,
        showConfirmButton: false
    });
}

export function closeSwlLodiang() {
    Swal.close();
}

export function showSwlLoadingError(text = '', allowOutsideClick = true) {
    Swal.fire({
        icon: 'error',
        title: '¡Lo sentimos!',
        text: text,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn bg-gradient-dark'
        },
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export function showSwlLoadingInfo(text = '', allowOutsideClick = true) {
    Swal.fire({
        icon: 'info',
        text: text,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn bg-gradient-dark'
        },
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export function showSuccess(text = '', allowOutsideClick = true) {
    Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: text,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn bg-gradient-dark'
        },
        allowOutsideClick: allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export function showAlert(text = '', allowOutsideClick = true) {
    Swal.fire({
        position: 'top-center',
        icon: 'success',
        text: text,
        showConfirmButton: false,
        timer: 1500,
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export async function showApiError(apiUrl, responseObj, errorObj, allowOutsideClick = true) {
    let url;
    let errorMessage = 'Error';
    let statusMessage;

    if (apiUrl) {
        const splitApiUrl = apiUrl.split('/');
        url = `${splitApiUrl[splitApiUrl.length - 2]}/${splitApiUrl[splitApiUrl.length - 1]}`;
    }

    if (responseObj) {
        if (responseObj?.message?.error) {
            errorMessage = `${responseObj?.message?.error}`;
            url = '';
        } else if (responseObj?.message) {
            errorMessage = `${responseObj?.message}`;
            url = '';
        } else if (responseObj?.response?.message) {
            errorMessage = `${responseObj.response.message}`;
            url = '';
        } else if (responseObj?.error?.message) {
            errorMessage = `${responseObj.error.message}`;
            url = '';
        } else {
            errorMessage = 'Hubo un problema.';
            statusMessage = `Estatus: ${responseObj.status}`;
        }
    } else if (errorObj) {
        if (errorObj?.message) {
            errorMessage = `${errorObj.message}`;
        }
    }

    await Swal.fire({
        icon: 'error',
        title: '¡Lo sentimos!',
        html: `<h5>${url || ''}</h5>
          <p>${errorMessage}</p>
          <p>${statusMessage || ''}</p>`,
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}
